import {
  Commitment,
  Relationship,
} from "@/services/backend/relationships/types/relationship";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/shared/components/ui/sheet";
import { CommitmentCard } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/_components/commitment-card";
import { DocumentCard } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/_components/document-card";
import { Button } from "@/shared/components/ui/button";

export function CommitmentSheet({
  triggerText = "Arbeiten",
  relationship,
  commitment,
}: {
  triggerText?: string;
  relationship: Relationship;
  commitment: Commitment;
}) {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="link" size="sm" className="h-6 cursor-pointer px-0">
          {triggerText}
        </Button>
      </SheetTrigger>
      <SheetContent side="bottom" className="max-h-[90vh] overflow-y-auto">
        <div className="grid gap-2 p-4 pt-12">
          <CommitmentCard commitment={commitment!} />
          <DocumentCard relationship={relationship!} commitment={commitment!} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
